import { ReservationStatus } from "@/lib/types/reservation";
import { UserType } from "@/lib/types/user";
import { VisitorType } from "@/lib/types/visitor";


export const apiErrorMessages: Record<string, string> = {
    DeleteNotAllowed: 'error.deleteNotAllowed',
    InvalidTimeRange: 'error.invalidTimeRange',
    TooDistant: 'error.tooDistant',
    ResourceAlreadyBooked: 'error.resourceAlreadyBooked',
    ResourceCapacityExceeded: 'error.resourceCapacityExceeded',
    ResourceUnderMaintenance: 'error.resourceUnderMaintenance',
    ResourceCapacityReducedByMaintenance: 'error.resourceCapacityReducedByMaintenance',
    ResourceWithoutAvailability: 'error.resourceWithoutAvailability',
    ResourceAvailabilityNotFullyCovered: 'error.resourceAvailabilityNotFullyCovered',
    MaintenanceConflictsWithReservations: 'error.maintenanceConflictsWithReservations',
    InvalidReducedCapacity: 'error.invalidReducedCapacity',
    InvalidTimezone: 'error.invalidTimezone',
    Overlapping: 'error.overlapping'
}

export function getErrorMessage(errorMessage: ErrorMessage, t: (key: string) => string): string {
    return errorMessage.errorCode ? t(apiErrorMessages[errorMessage.errorCode] || '') : errorMessage.message;
}

export function getUserTypeLabel(userType: UserType): string {
    switch (userType) {
        case UserType.User:
            return "users.types.user";
        case UserType.Admin:
            return "users.types.admin";
        case UserType.SuperAdmin:
            return "users.types.superAdmin";
        default:
            return "users.types.unknown";
    }
}

export function getReservationStatusLabel(status: ReservationStatus): string {
    switch (status) {
        case ReservationStatus.Planned:
            return "status.planned";
        case ReservationStatus.Canceled:
            return "status.canceled";
        case ReservationStatus.Completed:
            return "status.completed";
        default:
            return "status.unknown";
    }
}

export function getVisitorTypeLabel(visitorType: VisitorType): string {
    switch (visitorType) {
        case VisitorType.NonProfessional:
            return "visitor.type.nonProfessional";
        case VisitorType.NewProfessional:
            return "visitor.type.newProfessional";
        case VisitorType.ErpProfessional:
            return "visitor.type.erpProfessional";
        default:
            return "visitor.type.unknown";
    }
}
